import React from "react";

import "./styles.scss";
import { LocationActivityTableRow } from "../Row";

interface LocationActivityTableHeaderProps {
  sortField?: string;
  sortDirection?: string;
  handleSort: (sortField: string) => void;
}

export const LocationActivityTableHeader: React.FunctionComponent<
  LocationActivityTableHeaderProps
> = ({ sortField, sortDirection, handleSort }) => {
  return (
    <div className="location-activity-table-header">
      <LocationActivityTableRow
        isHeader={true}
        sortField={sortField}
        sortDirection={sortDirection}
        handleSort={handleSort}
      />
    </div>
  );
};
